import { titlePerPath } from "../const";
import { Guide, MainPath } from "../types/types";
import { getDocTitleSlug } from "./getDocTitleSlug";
import { normalizePermalink } from "./normalizePermalink";

// TODO: query this info?
export const notFoundUrl = "/404/";

export type RootPageParams = {
  path: "root";
};

export type NotFoundPageParams = {
  path: "not-found";
};

interface DocPageParams {
  path: string;
  version: string;
  latestVersion: string;
  language?: string;
  permalink: string;
  title?: string;
  hash?: string;
  slug?: string;
}

export type ReleaseNotesPageParams = {
  path: "release_notes";
  language?: string;
  slug: string;
  hash?: string;
};

export type BuildAppUrlParams =
  | RootPageParams
  | NotFoundPageParams
  | DocPageParams
  | ReleaseNotesPageParams;


  export function buildDocPageUrl({
    version,
    language = "en",
    path,
    permalink,
    title,
    hash = "",
  }: DocPageParams): string {
    const titleSlug = getDocTitleSlug(title);

    return encodeURI(
      `/${language}/${version}/${path}/${permalink}/${titleSlug}/${hash}`
    );
  }


export function buildReleaseNotesPageUrl({
  slug,
  hash = "",
}: ReleaseNotesPageParams): string {
  const url = encodeURI(`${slug}${hash}`);

  // The returned URL must start with "/release_notes".
  //
  const index = url.indexOf("/release_notes");
  if (index === -1) {
    // Not found.
    return url;
  }

  return url.substring(index);
}

export function buildAppUrl(params: BuildAppUrlParams): string {
  if (params.path === "release_notes") {
    return buildReleaseNotesPageUrl(params as ReleaseNotesPageParams);
  } else if (params.path === "root") {
    return "/";
  } else if (params.path === "not-found") {
    return notFoundUrl;
  } else {
    return buildDocPageUrl(params as DocPageParams);
  }
}

export function buildGuideIndexUrl({
  guide,
  version,
  latestVersion,
  language,
  hash,
}: {
  guide: Guide;
  version: string;
  latestVersion: string;
  language?: string;
  hash?: string;
}) {
  return buildAppUrl({
    latestVersion,
    permalink: normalizePermalink({ guide }),
    title: titlePerPath[guide],
    path: guide,
    version,
    language,
    hash,
  });
}

export function buildReleaseNotesIndexUrl({ hash }: { hash?: string }): string {
  return buildReleaseNotesPageUrl({
    path: "release_notes",
    slug: "/release_notes/",
    hash,
  });
}

export function buildPathIndexUrl({
  language,
  hash,
  latestVersion,
  version,
  path,
}: {
  language?: string;
  hash?: string;
  version: string;
  latestVersion: string;
  path: MainPath;
}) {
  if (path === "release_notes") {
    return buildReleaseNotesIndexUrl({
      hash,
    });
  } else {
    return buildGuideIndexUrl({
      guide: path,
      latestVersion,
      hash,
      language,
      version,
    });
  }
}
